import { Divider, HStack, Text, VStack } from "@chakra-ui/react";

interface CreativeTextSectionProps {
  primaryText?: string;
}

const CreativeTextSection = ({ primaryText }: CreativeTextSectionProps) => {
  return (
    <>
      <HStack
        justifyContent="space-between"
        gap={4}
        flexGrow={1}
        w="full"
        alignItems="flex-start"
        fontWeight="medium"
      >
        <VStack flexGrow={1} alignItems="flex-start">
          <Text color="gray.500" fontWeight="medium">
            Primary text
          </Text>
          <Text>{primaryText}</Text>
        </VStack>
      </HStack>
    </>
  );
};

export default CreativeTextSection;
